<app-realized-work-page-header [form]="form"></app-realized-work-page-header>
<ng-template #buttons>
    <app-button
        icon="pi-print"
        label="workData.printDialog.buttons.print"
        (clickEvent)="printRecords()"
    ></app-button>
</ng-template>
<app-table
    tableKey="workVisits"
    [gridData]="$any(store.data.getWorks())"
    [refreshCallbackFragment]="getWorksFrag"
    [transformItem]="workHideDelete()"
    [columns]="columns"
    translatePrefix="workData.visit."
    [buttons]="extendedWorkExportsEnabled ? buttons : null"
    [showSearch]="true"
    [showColumnVisiblity]="true"
    [showExport]="true"
    (deleteCallbackWithEvent)="delete($event)"
    (detailCallback)="detail($event)"
    [additionalFilter]="extraFilters()"
    [refreshCallback]="store.api.getWorks"
    [additionalContextMenuActions]="contextMenuItems"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
    @if (extendedWorkExportsEnabled) {
        <ng-template pTemplate="link" let-item="item">
            <app-button
                styleClass="tableIcon"
                svgIcon="pdf"
                [text]="true"
                (clickEvent)="$event.stopPropagation(); printRecord(item)"
            ></app-button>
        </ng-template>
    }

    <ng-template pTemplate="footer" let-items="items" let-columns="columns">
        <tr>
            <td>{{ 'summary' | translate }}:</td>
            @if (extendedWorkExportsEnabled) {
                <td></td>
            }
            <td></td>
            @for (col of columns; track col.name) {
                <td>
                    @if (col.name === 'workData.wdv.distanceFrom' || col.name === 'workData.wdv.distanceTo') {
                        <span>{{ items | workSum: col.name }}&nbsp;km</span>
                    } @else if (col.name === 'dateFrom') {
                        <span>{{ 'database.workVisits.uniqueDates' | translate }}{{ items | workUniqueDays }}</span>
                    } @else if (col.name === 'users') {
                        <span>{{ 'database.workVisits.uniqueWorkers' | translate }}{{ items | workUniques: 'users' }}</span>
                    } @else if (col.name === 'folder') {
                        <span>{{ 'database.workVisits.uniqueFolders' | translate }}{{ items | workUniques: 'folderId' }}</span>
                    }
                </td>
            }
            <td></td>
        </tr>
    </ng-template>

    <ng-template pTemplate="folderFormData" let-item="item">
        <app-folder-form-data-work-column [work]="item"></app-folder-form-data-work-column>
    </ng-template>

    <ng-template pTemplate="voucherNumber" let-item="item">
        {{ item?.performedProcedures?.[0]?.voucherPrescribedMedicalProcedure?.voucher?.sequenceNumber }}
    </ng-template>

</app-table>

<p-confirmpopup key="workSignConfirm"></p-confirmpopup>
